import React from 'react';
import { Box, Rating, Typography } from '@mui/material';

interface Props { rating?: number | null; count?: number; label?: string; }
export default function CustomerRating({ rating, count, label = 'Customer rating' }: Props) {
  const valid = typeof rating === 'number' && Number.isFinite(rating) && rating >= 1 && rating <= 5
    && (count === undefined || count > 0);
  return <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
    {valid ? <>
      <Rating value={rating} precision={0.1} readOnly size="small" aria-label={`${label}: ${rating.toFixed(1)} out of 5`} />
      <Typography variant="body2" fontWeight={650}>{rating.toFixed(1)}/5</Typography>
      {count !== undefined && <Typography variant="caption" color="text.secondary">({count} {count === 1 ? 'rating' : 'ratings'})</Typography>}
    </> : <Typography variant="body2" color="text.secondary">No ratings yet</Typography>}
  </Box>;
}
